/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { CustomFieldListItemDto } from '../models/custom-field-list-item.dto';

export const CustomFieldLisstItemMapper = entity<CustomFieldListItemDto>();
